// extracted by mini-css-extract-plugin
export var aboveInput = "_m5-0";
export var actionButton = "_m5-5";
export var actionButtonContainer = "_m5-1";
export var actionIcon = "_m5-6";
export var aiInfoContainer = "_m5-2";
export var attachmentWrapper = "_m5-7";
export var bold = "_m5-3";
export var checkIcon = "_m5-8";
export var clickingRecipientBar = "_m5-11";
export var commentThreadSwitch = "_m5-a";
export var draftImage = "_m5-b";
export var draftImageContainer = "_m5-c";
export var draftImages = "_m5-e";
export var editButton = "_m5-g";
export var editor = "_m5-f";
export var editorContainer = "_m5-y";
export var editorErrorTooltipWrapper = "_m5-9";
export var headerDivider = "_m5-h";
export var icon = "_m5-i";
export var info = "_m5-j";
export var internal = "_m5-n";
export var internalDivider = "_m5-k";
export var internalMessage = "_m5-l";
export var messageInputCard = "_m5-m";
export var messageInputForm = "_m5-o";
export var messageInputFormInternal = "_m5-p";
export var options = "_m5-q";
export var publicMessageCustomer = "_m5-s";
export var publicMessageMerchant = "_m5-r";
export var removeImageButton = "_m5-d";
export var replyButtons = "_m5-t";
export var showSignatureButton = "_m5-u";
export var spinner = "_m5-v";
export var verticalButtonDivider = "_m5-4";
export var visibilitySelector = "_m5-w";
export var warning = "_m5-x";
export var wrappingText = "_m5-z";
export var writingInternalNoteTopBorder = "_m5-10";